__turbopack_context__.v({
  "carouselWrapper": "BuySection-module__Ql9lfq__carouselWrapper",
  "container": "BuySection-module__Ql9lfq__container",
  "desktopHeading": "BuySection-module__Ql9lfq__desktopHeading",
  "mobileHeading": "BuySection-module__Ql9lfq__mobileHeading",
  "rightColumn": "BuySection-module__Ql9lfq__rightColumn",
});
